"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ssCommonKey = ssCommonKey;
var _0x15be = ['\x35\x42\x46\x34\x37\x30\x38\x39\x37\x35', '\x43\x32\x42\x39\x34\x35\x43\x45\x35\x38'];

(function (_0x305e8d, _0x15bee0) {
  var _0x2c09c6 = function _0x2c09c6(_0x50eda4) {
    while (--_0x50eda4) {
      _0x305e8d['\x70\x75\x73\x68'](_0x305e8d['\x73\x68\x69\x66\x74']());
    }
  };

  _0x2c09c6(++_0x15bee0);
})(_0x15be, 0x163);

var _0x2c09 = function _0x2c09(_0x305e8d, _0x15bee0) {
  _0x305e8d = _0x305e8d - 0x0;
  var _0x2c09c6 = _0x15be[_0x305e8d];
  return _0x2c09c6;
};

function ssCommonKey() {
  var _0x1bc58c = _0x2c09;
  return '\x44\x41\x34\x33\x43\x31\x30\x38\x44\x41' + _0x1bc58c('\x30\x78\x31') + '\x43\x44\x30\x42\x33\x45\x38\x43\x32\x30' + _0x1bc58c('\x30\x78\x30') + '\x33\x34\x38\x39\x46\x31\x39\x32';
}